import { z } from 'zod4';

import { isoDatetimeToDate, isoDateToDate } from './dates';
import { fixture } from './fixtures';

export const CheckInSettings = z.object({
	mandatory: z.boolean(),
	effectiveDate: isoDateToDate.nullable(),
	announce: z.boolean(),
});

export type CheckInSettings = z.infer<typeof CheckInSettings>;

export const CheckIn = z.object({
	id: z.string().default(''),
	userId: z.string(),
	score: z.number(),
	message: z
		.string()
		.nullable()
		.transform((val) => val ?? ''),
	meetingId: z
		.string()
		.nullable()
		.transform((val) => val ?? ''),
	createdAt: isoDatetimeToDate,
	updatedAt: isoDatetimeToDate,
});

export type CheckIn = z.infer<typeof CheckIn>;

// Fixture functions
export const checkInSettingsFixture = (overrides: Partial<CheckInSettings> = {}): CheckInSettings => ({
	mandatory: fixture.boolean(),
	effectiveDate: fixture.futureDate(),
	announce: fixture.boolean(),
	...overrides,
});

export const checkInFixture = (overrides: Partial<CheckIn> = {}): CheckIn => ({
	id: fixture.id(),
	userId: fixture.id(),
	score: fixture.int(1, 5),
	message: '',
	meetingId: '',
	createdAt: fixture.pastDate(),
	updatedAt: fixture.date(),
	...overrides,
});
